// extracted by mini-css-extract-plugin
export default {"root":"GettingStartedPage-module--root--79762","titleRow":"GettingStartedPage-module--titleRow--bf219"};